export default __webpack_public_path__ + "static/pith-7e0b5620799123fb8d90a5be8d98d579.png";